import React, { useEffect, useState } from 'react';
import { Route, Switch, Redirect, withRouter } from 'react-router-dom';
import Navbar from '../components/navbar';
import Dashboard from '../components/dashboard';
import Calendar from '../components/calendar';
import Scheduled from '../components/scheduled';

const Master = (props) => {
    const [status,              setStatus]              = useState('All');

    return (  
        <>                    
            <Navbar 
                status={status} 
                setStatus={setStatus} 
            />
            <Switch>
                <Route path="/dashboard">
                    <Dashboard 
                        status={status} 
                        setStatus={setStatus} 
                    />
                </Route>
                <Route path="/calendar">
                    <Calendar />
                </Route>
                <Route path="/scheduled">
                    <Scheduled />
                </Route>
                <Redirect to="/dashboard" />
            </Switch>
        </>
    )
}

export default withRouter(Master);